import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { ModalController, Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { of } from 'rxjs/observable/of';
import { TextControlMobileModalArgs } from '../../../../app/modals-popovers/text-control-mobile-modal/text-control-mobile-modal';
import { Lookup } from '../../../business-objects/lookup/lookup.model';
import { ILookupFormArgs } from '../../../pages/lookup-form/lookup-form';
import { VasAppFacade } from '../../../services/vas-app-facade.service';
import * as actions from './text-control.actions';

@Injectable()
export class TextControlEffects {

    @Effect()
    init$ = this.actions$
        .ofType(actions.INIT)
        .switchMap((action: actions.InitAction) => {

            if (!action.payload.control.config.searchEnabled) {
                return of(new actions.InitSuccessAction({
                    control: action.payload.control,
                    instanceKey: action.payload.instanceKey,
                    inputValue: action.payload.inputValue,
                    lookups: []
                }));
            }

            return this.appFacade.objects.lookup.store
                .getBy(lookup =>
                    lookup.lookupType === action.payload.control.config.lookupType
                )
                .map(lookups => new actions.InitSuccessAction({
                    control: action.payload.control,
                    inputValue: action.payload.inputValue,
                    instanceKey: action.payload.instanceKey,
                    lookups
                }))
                .take(1)
                .catch(error => of(new actions.InitFailAction({
                    instanceKey: action.payload.instanceKey,
                    error
                })));
        });

    @Effect()
    newLookup$ = this.actions$
        .ofType(actions.NEW_LOOKUP)
        .switchMap((action: actions.NewLookupAction) => {

            const modal = this.modalController.create('LookupForm', {
                account: action.payload.accountId,
                lookupTypeId: action.payload.lookupTypeId,
                accessGroupId: action.payload.accessGroupId
            } as ILookupFormArgs);

            modal.present();

            return fromPromise(new Promise((resolve, reject) => {
                modal.onDidDismiss(() => {
                    resolve(new actions.ReloadLookupsAction({
                        instanceKey: action.payload.instanceKey,
                        lookupType: action.payload.lookupTypeId
                    }));
                });
            }));
        });

    @Effect()
    reloadLookups$ = this.actions$
        .ofType(actions.RELOAD_LOOKUPS)
        .switchMap((action: actions.ReloadLookupsAction) => {
            return this.appFacade.objects.lookup.store
                .getBy(lookup =>
                    lookup.lookupType === action.payload.lookupType
                )
                .map(lookups => new actions.ReloadLookupsSuccessAction({
                    lookupTypeId: action.payload.lookupType,
                    lookups
                }))
                .take(1)
                .catch(error => of(new actions.ReloadLookupsFailAction({
                    instanceKey: action.payload.instanceKey,
                    error
                })));
        });

    @Effect()
    showAll$ = this.actions$
        .ofType(actions.SHOW_ALL)
        .switchMap((action: actions.ShowAllAction) => {

            return this.core$
                .map(core => core ?
                    new actions.ShowAllDesktopAction(action.payload) :
                    new actions.ShowAllMobileAction(action.payload)
                );
        });

    @Effect()
    showAllDesktop$ = this.actions$
        .ofType(actions.SHOW_ALL_DESKTOP)
        .switchMap((action: actions.ShowAllDesktopAction) => {
            return of(new actions.ShowAllDesktopSuccessAction({
                instanceKey: action.payload.instanceKey
            }));
        });

    @Effect()
    showAllMobile = this.actions$
        .ofType(actions.SHOW_ALL_MOBILE)
        .switchMap((action: actions.ShowAllDesktopAction) => {

            const modal = this.modalController.create(
                'TextControlMobileModal',
                {
                    lookupTypeId: action.payload.lookupTypeId
                } as TextControlMobileModalArgs
            );

            modal.present();

            return fromPromise(new Promise((resolve, reject) => {
                modal.onDidDismiss(lookupId => {
                    resolve(new actions.ShowAllMobileSuccessAction({
                        instanceKey: action.payload.instanceKey,
                        lookupId
                    }));
                });
            }));
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade,
        protected platform: Platform,
        protected modalController: ModalController
    ) {
    }

    get core$(): Observable<boolean> {
        return of(this.platform.is('core'));
        // return of(false);
    }

    getLookups(lookupTypeId: string): Observable<Array<Lookup>> {
        return this.appFacade.objects.lookup.store
            .getBy(lookup =>
                lookup.lookupType === lookupTypeId
            )
            .take(1);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/text/form/text-control.effects.ts